var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeTranscriptsScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9cb5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22512,
    stopColor: "#ff5663"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48883,
    stopColor: "red"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96004a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M74.87164,68.38538v-11.93445c0-1.87158-1.51727-3.38879-3.38885-3.38879h-14.58655c-1.87158,0-3.38879,1.51721-3.38879,3.38879v11.93445c0,1.87158,1.51721,3.38879,3.38879,3.38879h14.58655c1.87158,0,3.38885-1.51721,3.38885-3.38879ZM66.86218,64.30908h-8.81824c-.66138,0-1.19757-.53619-1.19757-1.19763,0-.66138.53619-1.19751,1.19757-1.19751h8.81824c.66144,0,1.19757.53613,1.19757,1.19751,0,.66144-.53613,1.19763-1.19757,1.19763ZM70.33508,59.34955h-12.29114c-.33069,0-.63013-.13403-.8468-.35077-.21674-.21667-.35077-.51611-.35077-.8468,0-.66144.53619-1.19757,1.19757-1.19757h12.29114c.66144,0,1.19757.53613,1.19757,1.19757,0,.66138-.53613,1.19757-1.19757,1.19757Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.32104,61.91394h18.1864v-5.46301c0-4.07422,3.31458-7.38879,7.38879-7.38879h13.01172v-14.64374c0-3.42004-2.77246-6.19263-6.19257-6.19263H31.32104c-3.4201,0-6.19269,2.77258-6.19269,6.19263v21.30292c0,3.4201,2.77258,6.19263,6.19269,6.19263ZM41.95947,36.0722l15.58441,8.99762-15.58441,8.99768v-17.9953Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeTranscriptsScraper);
export default __webpack_public_path__ + "static/media/youtube-transcripts-scraper.e31913f6fa16fa4bf773851a5ee5e724.svg";
export { ForwardRef as ReactComponent };